import { AppBar, Badge, IconButton, Toolbar } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './header.scss';
import { IRootState } from 'app/shared/reducers';
import { getDocument } from 'app/modules/cms/service/store/selectors';
import { useSelector } from 'react-redux';
import SideBar from 'app/shared/components/mobile/sideBar/sideBar';

const Header = props => {
  const { didomi } = props;
  const history = useHistory();
  const isAuthenticated: any = useSelector<IRootState>(state => state.authentication.isAuthenticated);
  const appStyle: any = useSelector<IRootState>(getDocument('app_global_type'));
  const bgImg = appStyle?.data?.main_logo?.url;
  const [menuOpen, setMenuOpen] = useState(false);
  const sideNavData = props.ListData?.HEADER?.params?.SIDE_NAV_ITEM?.sideNavItemList;

  const handleLogoClick = () => {
    if (isAuthenticated) {
      history.push('/home');
    }
  };

  const toggleMenu = () => {
    const menuButton = document.getElementById('menu-button');
    if (menuOpen) {
      menuButton.classList.remove('menu-active');
    } else {
      menuButton.classList.add('menu-active');
    }
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      <AppBar id="header" position="static">
        <SideBar didomiObject={didomi} menuOpen={menuOpen} setMenuClose={toggleMenu} items={sideNavData?.length ? sideNavData : []} sideNavCmsData={props.sideNavCmsData} />
        <Toolbar>
          {isAuthenticated && (
            <IconButton onClick={toggleMenu} id="menu-button" className="menu-button">
              <span className="burger-menu"></span>
              <span className="burger-menu"></span>
              <span className="burger-menu"></span>
            </IconButton>
          )}
          {bgImg && <img src={bgImg} alt="Bouygues icône" className="app-logo" onClick={handleLogoClick} />}
        </Toolbar>
      </AppBar>
    </>
  );
};
export default Header;
